<template>
    <div>
        <form class="section__content form">
            <h1 class="admin__title">Users ({{ users.length }})</h1>
            <fieldset class="form__group">
                <section class="form__item__input input">
                    <input placeholder="Search for a user by name or email...)" type="text" class="input__field"  v-model="userSearch" />
                </section>
                <article v-if="searchMatch(item)" v-for="item in users" class="form__item form__item--show-border">
                    <label class="form__item__label">
                        <h2 class="form__item__name">{{ item.name }} {{ item.id == me.id ? "(You)" : ""}}</h2>
                        <small>{{ item.email }}</small>
                    </label>
                    <label class="form__item__label">
                        <small>Admin?</small>
                        <boolean @input="toggleAdmin(item.id, ...arguments)" :defaultValue="item.admin" :id="(item.id + '_admin')"></boolean>
                    </label>
                    <label class="form__item__label">
                        <small>Format Admin?</small>
                        <boolean @input="toggleFormatAdmin(item.id, ...arguments)" :defaultValue="item.format_admin" :id="(item.id + '_format_admin')"></boolean>
                    </label>
                </article>
            </fieldset>
        </form>
    </div>
</template>

<script>
  import {mapState} from 'vuex'
  import Boolean from '../configurator/Boolean'

  export default {
    name: 'AdminUsers',
    components: {
      Boolean
    },
    data () {
      return {
        userSearch: ''
      }
    },
    methods: {
      searchMatch (item) {
        return item.email.toUpperCase().indexOf(this.userSearch.toUpperCase()) > -1 || item.name.toUpperCase().indexOf(this.userSearch.toUpperCase()) > -1;
      },
      toggleFormatAdmin (user_id, value) {
        this.$store.dispatch('users/update', {userId: user_id, payload: {format_admin: value}})
      },
      toggleAdmin (user_id, value) {
        if (user_id == this.me.id) return;
        this.$store.dispatch('users/update', {userId: user_id, payload: {admin: value}})
      }
    },
    computed: {
      ...mapState('users', {users: 'all'}),
      ...mapState(['me'])
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/AdminUsers.vue